import request from '@/utils/request'

export function reg(form) {
	return request.post('/cust/register', form);
}

/**
 * 用户登录（验证码登录和密码登录，如果是密码登录：loginType: 验证码登录：VLTC 密码登录：PLTC 登录密码设置身份信息验证登录：ALTTC）
 * @param {*} form {mobile: mobile, loginCode: loginCode, loginType: loginType}
 * @returns 
 */
export function login(form) {
	return request.post('/cust/login', form);
}

/**
 * 定制化产品点击分享链接登录接口
 * @param {*} form {mobile: mobile, loginCode: loginCode, loginType: loginType, productId: 产品id, parentId: 上级分享人用户id}
 * @returns 
 */
export function productLogin(form) {
	return request.post('/cust/custom/product/login', form);
}

/**
 * 是否有查看产品详情的权限
 * @param {*} productId 
 * @returns 
 */
export function customizedProductPreach(productId) {
	return request.post('/share/customizedProductPreach', { productId: productId })
}

/**
 * 是否有产品专享的分享权限
 * @param {*} sectionId 
 * @returns 
 */
export function sectionProductPreach(sectionId) {
	return request.post('/share/sectionProductPreach', { sectionId: sectionId })
}

/**
 * 获取专区分享信息
 * @param {*} sectionId 
 * @returns 
 */
export function sectionInfo(sectionId) {
	return request.post('/share/section/info', { id: sectionId })
}

/**
 * 发送验证码
 * @param {*} {
 * phone
 * sign
 * r
 * } 
 * @returns 
 */
export function sendcode(params) {
	return request.post('/cust/de6GMcC9LtL0vR0q', params);
}

export function sendcodeWithout() {
	return request.post('/cust/sendcodeWithout');
}

/**
 * 获得用户详细的信息
 * @param {*} phone 
 */
export function getcust() {
	return request.post('/cust/getcust');
}



/**
 * 通过手机号判断用户是否存在
 * @param {*} phone 
 * 
 */
export function existbyphone(form) {
	return request.post('/cust/existbyphone', form);
}

export function realname(form) {
	return request.post('/cust/realname', form);
}

/**
 * 设置手势密码
 * @param {*} form 
 */
export function sethandpwd(form) {
	return request.post('/cust/sethandpwd', form);
}

export function tradepwd(form) {
	return request.post('/cust/tradepwd', form);
}

/**
 * 渠道 - 授权登录获取信息
 * @param {*} form 
 */
export function getauthphone(form) {
	return request.post('/cust/getauthphone', form);
}

/**
 * 渠道 - 确认授权
 * @param {*} form 
 */
export function confirmauth(form) {
	return request.post('/cust/confirmauth', form);
}

export function userInfo() {
	return request.post('/cust/getcust');
}

export function paylist() {
	return request.post('/cust/paylist');
}

export function buyper() {
	return request.post('/cust/buypre');
}

// 获取用户绑卡信息
export function listBindCard() {
	return request.post('/cust/listBindCard');
}

// 发送验证码
export function withdrawcode() {
	return request.post('cust/withdrawcode');
}

export function editMobile(form) {
	return request.post('cust/editMobile', form);
}

export function editCard(id) {
	return request.post('cust/editCard', { id });
}

export function cancleCard(id) {
	return request.post('cust/cancleCard', { id });
}

export function editDeviceInfo(deviceToken) {
	return request.post('cust/editDeviceInfo', { deviceToken });
}

export function getChanlBackUrl() {
	return request.post('cust/getChanlBackUrl');
}

export function getchanlbindinfo() {
	return request.post('cust/getchanlbindinfo');
}

export function addAddress(form) {
	return request.post('cust/addaddress', form);
}

export function addressDefault(form) {
	return request.post('cust/addressdefault', form);
}

export function delAddress(id) {
	return request.post('cust/deladdress', { id });
}

export function getChanlWithdraw() {
	return request.post('cust/getchanlwithdraw');
}

export async function getMyInviteList(form) {
	return request.post('/cust/invitation', form)
}
/**
 * 获取分享二维码URL
 * @returns 
 */
export function getQRCode() {
	return request.post('/common/getQRCode')
}

/**
 * 设置登录密码
 * @param {*} params {pwd: pwd, confirmPwd: confirmPwd, phone: phone}  未登录状态，phone必填
 * @returns 
 */
export function setLoginPwd(params) {
	return request.post('/cust/setPwd', params)
}

/**
 * 更新登录密码(如果未登陆，则手机号必传，否则，手机号选填)
 * @param {*} params {phone: phone, code: code, pwd: pwd, confirmPwd: confirmPwd}
 * @returns 
 */
export function updateLoginPwd(params) {
	return request.post('/cust/updatePwd', params)
}

/**
 * 省市区三级联动接口
 * @returns 
 */
export function countryAreasList() {
	return request.post('/countryAreas/getList')
}

/**
 * 地址新增接口
 * @param {*} params {phone:15620691809
 * custName:收货人
area：上海市上海市静安区
detailAddress：南京西路1717号会德丰国际广场
isDefault：0-默认 1- 非默认}
 * @returns 
 */
export function addMyAddress(params) {
	return request.post('/address/addAddress', params)
}

/**
 * 地址修改接口
 * @param {*} params {请求入参：id:1
 * custName:收货人
phone:15620691809
area：上海市静安区
detailAddress：南京西路1717号会德丰国际广场36F
isDefault：0-默认 1- 非默认}
 * @returns 
 */
export function editMyAddress(params) {
	return request.post('/address/editAddress', params)
}

/**
 * 地址删除接口
 * @param {*} id
 * @returns 
 */
export function deleteMyAddress(id) {
	return request.post('/address/deleteAddress', { id: id })
}

/**
 * 地址列表接口
 * @returns 
 */
export function getMyAddressList() {
	return request.post('/address/getList')
}

/**
 * 地址详情接口

 * @param {*} params {id: 1}
 * @returns 
 */
export function getMyAddress(params) {
	return request.post('/address/getAddress', params)
}

/**
 * 判断手机号是否已绑定微信
 * @param {*} phone 绑定微信手机号码
 * @param {*} code 微信openid
 * @returns 
 */
export function preAuth(phone, code) {
	return request.post("/wechat/preAuth", { phone: phone, code: code })
}

/**
 * 微信登录授权
 * @param {*} params {code: code } 
 * @returns 
 */
export function getWechatAuth(params) {
	return request.post('/wechat/auth', params)
}

/**
 * 微信绑定
 * @param {*} code 微信code
 * @returns 
 */
export function getWechatBind(code) {
	return request.post("/wechat/bind", { code: code })
}

/**
 * 解除微信绑定
 * @returns 
 */
export function deleteWechatBind() {
	return request.post("/wechat/unbind")
}

/**
 * 验证码验证接口
 * @param {*} phone 
 * @param {*} code 
 * @returns 
 */
export function authCode(phone, code) {
	return request.post('/cust/authcode', { phone: phone, code: code })
}

export function registerAuthCode(phone, code, referrerCode, referrerType) {
	return request.post('/cust/registerAuthCode', { phone: phone, code: code, referrerCode: referrerCode, referrerType: referrerType })
}

/**
 * 页面追踪
 * @param {*} params 
 * @returns 
 */
export function pageTrack(params) {
	return request.post('/mq/track', params)
}

export function updateVipAddress() {
	return request.post("/cust/updateVipAddress")
}

export function getInviteCust(searchKey) {
	return request.get(`/cust/getInviteCust?custIdOrPhone=${searchKey}`)
}

export function systemUpdateing() {
	return request.post('/503')
}

export function getCustNotice() {
	return request.post("/cust/notice")
}

export function updateDefaultCode(params) {
	return request.post('/cust/updateDefaultCode', params)
}